import type { TourScenario, TourStep } from './types';

export const DASHBOARD_TARGET = {
  subject: 'dashboard-subject',
  tiles: 'dashboard-tiles',
  menu: 'dashboard-menu',
} as const;

export const DASHBOARD_TOUR_ID = 'dashboard' as const;

export type DashboardTargetId = typeof DASHBOARD_TARGET[keyof typeof DASHBOARD_TARGET];

type DashboardStep = Omit<TourStep, 'targetId'> & {
  targetId: DashboardTargetId;
};

export type DashboardScenario = Omit<TourScenario, 'id' | 'steps'> & {
  id: typeof DASHBOARD_TOUR_ID;
  steps: DashboardStep[];
};

export const buildDashboardScenario = (): DashboardScenario => ({
  id: DASHBOARD_TOUR_ID,
  steps: [
    {
      targetId: DASHBOARD_TARGET.subject,
      title: 'Wybór przedmiotu',
      description: 'Tu możesz w każdej chwili zmienić przedmiot, którego się uczysz.',
    },
    {
      targetId: DASHBOARD_TARGET.tiles,
      title: 'Kafelki funkcji',
      description: 'Tu jest reszta funkcjonalności — o każdej przeczytasz na kafelku albo po prostu kliknij i przetestuj.',
    },
    {
      targetId: DASHBOARD_TARGET.menu,
      title: 'Menu',
      description:
        'Będzie dostępne na każdym widoku. Stąd przejdziesz do każdej funkcjonalności, zmienisz przedmiot, ustawienia użytkownika, zgłosisz błąd albo wykupisz dostęp premium.',
    },
  ],
});

export const resolveDashboardScenario = (seenGuides: readonly string[]): DashboardScenario | null => {
  if (seenGuides.includes(DASHBOARD_TOUR_ID)) {
    return null;
  }

  return buildDashboardScenario();
};
